import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import Dropdown from "../../reusables/dropdown";
import {
  update_call_request,
  get_call_requests,
} from "../../../redux/actions/adminActions";
import InputField from "../../reusables/input";
import { call_status, periods } from "../../../utils/options";
import Spinner from "../../reusables/spinner";

function Customers({
  callRequests,
  updateStatus,
  getCallRequests,
  accessToken,
}) {
  const [status, setStatus] = useState("all");
  const [date, setDate] = useState("All Date");
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const [searchVal, setSearchVal] = useState("--");

  const [optionsActive, setOptions] = useState(null);

  const [selectedTime, setTime] = useState("All dates");

  const handleSelectTime = (Item) => {
    setTime(Item);
    setLoading(true);
    getCallRequests("user", status, searchVal, Item, accessToken, () =>
      setLoading(false)
    );
  };

  const handleOptions = (id) => {
    if (optionsActive === null) {
      setOptions(id);
    } else {
      setOptions(null);
    }
  };

  const handleUpdate = (id) => {
    // setOptions(null);
    setLoading2(true);
    updateStatus(id, "user", accessToken, () => {
      getCallRequests("user", status, searchVal, date, accessToken, () =>
        setLoading2(false)
      );
    });
  };

  const handleFilter = (status) => {
    setStatus(status);
    getCallRequests("user", status, searchVal, date, accessToken, () =>
      setLoading(false)
    );
  };

  useEffect(() => {
    getCallRequests("user", status, searchVal, date, accessToken, () =>
      setLoading(false)
    );
  }, []);

  const searchHandler = (e) => {
    e.preventDefault();
    getCallRequests("user", status, searchVal, date, accessToken, () =>
      setLoading(false)
    );
  };

  const handleSearchChange = (e) => {
    setSearchVal(e.target.value);
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween mobileBlock">
          <div className="searchHolder">
            <InputField
              placeholder="Search by name, phone number or email"
              icon
              iconClass="ri-search-line"
              iconClick={searchHandler}
              onChange={handleSearchChange}
            />
          </div>

          <div className="alignOnly pt-2">
            <Dropdown value={selectedTime} className="mx-1">
              {periods?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleSelectTime(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
            <Dropdown value={status} className="mx-1">
              {call_status?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleFilter(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
          </div>
        </div>

        <div className="sectionHeight--mid scrollable--mobile pt-4">
          {!loading ? (
            callRequests?.length > 0 ? (
              <table className="table">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Name</th>
                    <th className="vAlign">Mobile</th>
                    <th className="vAlign">Email</th>
                    <th className="vAlign">Address</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">Status</th>
                    {status !== "Done" && <th className="vAlign">Action</th>}
                  </tr>
                </thead>

                <tbody className="">
                  {callRequests?.map((request) => (
                    <tr className="hasRadius">
                      <td className="alignOnly">
                        <input
                          type="checkbox"
                          className="isClickable"
                          name=""
                          id=""
                        />

                        <div className="mx-1 alignOnly">
                          <div className="supplier__image mx-2">
                            <img
                              src={request.user?.display_pic}
                              className="w-100"
                              alt=""
                            />
                          </div>

                          <p className="mb-0 textIsBold sectionText">
                            {request.user?.first_name} {request.user?.last_name}
                          </p>
                        </div>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">
                          {request.user?.phone}
                        </p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0 sectionText">
                          {request.user?.email}
                        </p>
                      </td>

                      <td className="vAlign pt-4 address">
                        <p className="mb-0 sectionText">
                          {request.user?.address}
                        </p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">
                          {request.user?.date}
                        </p>
                      </td>

                      <td className="center pt-3">
                        <div
                          className={`tag ${
                            request.status === "done" && "done"
                          } ${request.status === "pending" && "pending"}`}
                        >
                          {request.status}
                        </div>
                      </td>

                      <td className="vAlign pt-4">
                        {status !== "Done" && (
                          <i
                            class="ri-more-line isClickable"
                            onClick={() => handleOptions(request.id)}
                          ></i>
                        )}

                        {optionsActive === request.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                              {!loading2 ? (
                                <div
                                  className=""
                                  onClick={() => handleUpdate(request.id)}
                                >
                                  Done
                                </div>
                              ) : (
                                <Spinner />
                              )}
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="sectionHeight--mid center w-100">
                <p className="mb-0 sectionHead--small textIsGreen textIsBold">
                  No requests found
                </p>
              </div>
            )
          ) : (
            <Spinner big />
          )}
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  callRequests: state.admin.callRequests.user,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  updateStatus: (id, type, token, success) =>
    dispatch(update_call_request(id, type, token, success)),
  getCallRequests: (type, status, search, date, token, success) =>
    dispatch(get_call_requests(type, status, search, date, token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Customers);
